// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"32d726c1","287":"2e6288cb","297":"93eb9ba8","678":"37d88c0c","708":"7bf614df","724":"f8bf21d2","823":"54f46dd7","914":"05a11219"}[chunkId] + ".chunk.js";
};